import React from 'react';

const IconArrowRight: React.FC = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 20" style={{ transform: 'scale(-1,1)' }}>
    <rect width="20" height="20" y="0" x="0" fill="none" stroke="currentColor" strokeWidth="3" transform="translate(0 0)"/>
  </svg>;
};

export default IconArrowRight;
